if (!window.debounce) {
    function debounce(fn, wait) {
      let t;
      return(...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  
  document.addEventListener("alpine:init", () => {
  
    const queryParams = window.getQueryParams();
    let page = 1;
    if (queryParams.page) {
      page = queryParams.page;
    }
  
    const getUrl = (data) => {
      const base = window.location.pathname;    
      const params = encodeQueryData(data);
      return `${base}?${params}`;
    }
  
    const encodeQueryData = (data) => {
      const ret = [];
      for (let d in data) {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
      return ret.join('&');
    }
  
    const sortOptions = window.getScriptJSONOrFail("data-sort-options");
    const filters = window.getScriptJSONOrFail("data-collection-filters-json");
  
    Alpine.store("facets", {
      ui: {
        productsLoading: false,
        mobileFiltersOpen: false,
        openFilter: null
      },
      searchParams: {
        view: "tailwind", // Temp
      },
      page: page,
      sortBy: "manual",
      selectedSortLabel: null,
      selectedFilters: filters || {},
      selectedFilterNames: [],
      init() {
        this.refreshSelectedSortLabel();
        const debouncedDisplay = debounce(() => {
          this.displayProducts();
        }, 1000);
        const onChangeState = () => {
          this.ui.productsLoading = true;
          if (this.ui.openFilter == 'sort') {
            this.ui.openFilter = '';
          }
  
          this.refreshSelectedFilterNames();
          this.refreshSelectedSortLabel();
          this.page = 1; // always reset to page 1
          debouncedDisplay();
        };
        this.$watch && this.$watch("sortBy", onChangeState);
        this.$watch && this.$watch("selectedFilters", onChangeState);
  
        this.$watch && this.$watch("page", debouncedDisplay);
      },
      navigateToPage(page) {
        this.page = parseInt(page);
      },
      toggleFilter(filter) {
        if (this.ui.openFilter == filter) { // clicking on the same filter should close it
          this.ui.openFilter = null;
        } else {
          this.ui.openFilter = filter;
        }
      },
      closeFilter(filter) {
        // We need this to specify which filter to close and not cause the open then close behavior that happens
        // when 2 or more filters are present in the page triggering toggleFilter(null)
        if (this.ui.openFilter == filter) {
          this.ui.openFilter = null;
        }
      },
      openMobileFilters(open = true) {
        this.ui.mobileFiltersOpen = open;
        if (Alpine.store("header")) {
          Alpine.store("header").blockBodyScrolling(open);
        }
      },
      openFilter(filter) {
        this.ui.openFilter = filter;
      },
      removeFilter(key, value) {
        this.selectedFilters[key] = this.selectedFilters[key].filter(f => f != value);
      },
      refreshSelectedSortLabel() {
        this.selectedSortLabel = sortOptions.find(so => so.value == this.sortBy).label;
      },
      refreshSelectedFilterNames() {
        this.selectedFilterNames = [];
        for (const filter in this.selectedFilters) {

          this.selectedFilterNames = [
            ...this.selectedFilterNames,
            ...this.selectedFilters[filter]
          ];
        }
      },
      formatFilterLabel(key, filterValue) {
        if(key.includes('Availability') || key.includes('availability')){
          return filterValue > 0 ? 'In stock' : 'Out of stock';
        } else {
          return filterValue;
        }
      },
      displayProducts() {
        this.ui.productsLoading = true;
  
        const sectionId = document.getElementById("collection-template").getAttribute("data-section-id");
  
        const url = getUrl({
          ...this.searchParams,
          ...this.selectedFilters,
          page: this.page,
          sort_by: this.sortBy,
          section_id: sectionId
        });
  
  // Check later if this is dangerous as we are relying on vanilla js now instead of alpine
        fetch(url).then(response => response.text()).then((responseText) => {
          const tempEl = document.createElement('div');
          tempEl.innerHTML = responseText;
  
          const replaceMarkerAttr = ["data-product-tiles", "data-product-pagination"];
          for (const attr of replaceMarkerAttr) {
            if (tempEl.querySelector(`[${attr}]`)) {
              const content = tempEl.querySelector(`[${attr}]`).innerHTML;
              document.querySelector(`[${attr}]`).innerHTML = content;
              overridePaginationBehavior();
              window.scrollTo({top: 0, behavior: "smooth"});
            } else {
              console.error("asm-collection.js", `[${attr}] was not found in the response`);
            }
          }
  
          this.ui.productsLoading = false;
        });
      }
    });
  
    const overridePaginationBehavior = () => {
      const paginationAnchors = document.querySelectorAll(".st-pagination a");
  
      const disableAnchors = () => {
        const loading = document.querySelector("[data-loading-message-markup]");
        document.querySelector(".st-pagination").innerHTML = loading.innerHTML;
      }
  
      for (const a of paginationAnchors) {
        const paginateTo = a.getAttribute("data-paginate-to");
        a.addEventListener('click', function(e) {
          e.preventDefault();              
          if (!isNaN(paginateTo)) {
            disableAnchors();
            Alpine.store("facets").navigateToPage(paginateTo);
          }
  
          const page = Alpine.store("facets").page;
  
          if (paginateTo == "next") {
            disableAnchors();
            Alpine.store("facets").navigateToPage(page + 1);
          }
  
          if (paginateTo == "previous" && Alpine.store("facets").page > 1) {
            disableAnchors();
            Alpine.store("facets").navigateToPage(page - 1);
          }
        });
      }
    };
  
    document.addEventListener('DOMContentLoaded', function() {
      overridePaginationBehavior();
    }, false);
  
  // const onHistoryChange = (event) => {
  // const searchParams = event.state ? event.state.searchParams : Alpine.store("facets").searchparams;
  // if (searchParams === FacetFiltersForm.searchParamsPrev) return;
  // FacetFiltersForm.renderPage(searchParams, null, false);
  // }
  
  // window.addEventListener("popstate", onHistoryChange);
  });